import React from 'react';

import CreateAnalysisModal from 'analysis-tool/create-analysis-modal/CreateAnalysisModal';
import isCreateAnalysisEnabled from 'analysis-tool/isCreateAnalysisEnabled';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import runModal from 'ui-library/runModal';

import CreateAnalyticsDashboardModal from './CreateAnalyticsDashboardModal';

function handleClickCreateDashboard(): void {
  runModal(CreateAnalyticsDashboardModal, {});
}
interface CreateAnalyticsDashboardButtonProps {
  className?: string;
}

function CreateDashboardButton({className}: CreateAnalyticsDashboardButtonProps): JSX.Element {
  return (
    <Tooltip title="Create dashboard" placement={TooltipPlacement.BOTTOM}>
      <Button
        buttonStyle={ButtonStyle.SECONDARY}
        className={className}
        icon="compose"
        onClick={handleClickCreateDashboard}
        size={ButtonSize.SMALL}
        dataTestAttrs={{component: 'CreateAnalyticsDashboardButton', element: 'button'}}
      />
    </Tooltip>
  );
}

function CreateDashboardOrAnalysisDropdown({className}: CreateAnalyticsDashboardButtonProps): JSX.Element {
  const menu = (
    <Menu dropLeft={true} width={Menu.WIDTHS.MEDIUM} height={Menu.HEIGHTS.MEDIUM}>
      <Option icon={ModelTypeConstants.ANALYTICS_DASHBOARD} onSelect={handleClickCreateDashboard}>
        Dashboard
      </Option>
      <Option
        icon={ModelTypeConstants.ANALYSIS}
        onSelect={() => {
          runModal(CreateAnalysisModal, {});
        }}
      >
        Analysis
      </Option>
    </Menu>
  );

  return (
    <Dropdown menu={menu}>
      <span>
        <Button
          buttonStyle={ButtonStyle.SECONDARY}
          className={className}
          icon="compose"
          size={ButtonSize.SMALL}
          dataTestAttrs={{component: 'CreateAnalyticsDashboardButton', element: 'button'}}
        />
      </span>
    </Dropdown>
  );
}

export default function CreateAnalyticsDashboardButton(
  props: CreateAnalyticsDashboardButtonProps
): JSX.Element {
  if (isCreateAnalysisEnabled()) {
    return <CreateDashboardOrAnalysisDropdown className={props.className} />;
  }
  return <CreateDashboardButton className={props.className} />;
}
